import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { RoutePath } from '@/section/router';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const tabs = [
  {
    label: "Birthday Fund Requests",
    path: RoutePath.BirthdayFundRequests,
  },
  {
    label: "Certificates Templates",
    path: RoutePath.BirthdayFundCertificates,
  },
  {
    label: "Certificate List",
    path: RoutePath.BirthdayFundCertificateList,
  },
  {
    label: "Certificate Designer",
    path: RoutePath.BirthdayFundCreateCertificate,
  },
];

export function BirthdayFundDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to requests tab by default
  useEffect(() => {
    if (location.pathname === RoutePath.BirthdayFund) {
      navigate(RoutePath.BirthdayFundRequests, { replace: true });
    }
  }, [location.pathname, navigate]);

  const isActiveTab = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="flex flex-col gap-4 overflow-hidden max-w-full h-full">
      {/* Header with page title buttons */}
      <div className="flex flex-row gap-2 items-center">
        {tabs.map((tab, index) => (
          <div key={tab.path} className="flex items-center">
            <Button
              variant="ghost"
              className={cn(
                "text-xl sm:text-2xl font-bold p-0 h-auto hover:bg-transparent",
                isActiveTab(tab.path)
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              )}
              onClick={() => navigate(tab.path)}
            >
              {tab.label}
            </Button>
            {index < tabs.length - 1 && (
              <span className="text-xl sm:text-2xl font-bold text-muted-foreground mx-2">/</span>
            )}
          </div>
        ))}
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
